import { ClassroomReadingLevelResponse, TrendLevel } from "@/reports/types";

export const classroomReadingLevelMockData: ClassroomReadingLevelResponse = {
  data: {
    filters_applied: {
      min_date: "2024-08-01",
      max_date: "2025-01-31",
      entity_type: "classroom",
      entity_id: "3bbdf574063e493ca0f059528204d50f",
      only_assigned_content: true,
    },
    data: {
      article_grade_level_viewed_average: 6,
      article_lexile_level_viewed_average: "895L",
      articles_viewed_count: 125,
      article_time_average: 12,
      articles_above_grade_level_count: 40,
      articles_at_grade_level_count: 17,
      articles_below_grade_level_count: 68,
      articles_weekly_trend_level: TrendLevel.Higher,
    },
  },
};
export const classroomReadingLevelNoActivitiesMockData: ClassroomReadingLevelResponse =
  {
    data: {
      filters_applied: {
        min_date: "2024-08-01",
        max_date: "2025-01-31",
        entity_type: "classroom",
        entity_id: "3bbdf574063e493ca0f059528204d50f",
        only_assigned_content: true,
      },
      data: {
        article_grade_level_viewed_average: 0,
        article_lexile_level_viewed_average: "0L",
        articles_viewed_count: 0,
        article_time_average: 0,
        articles_above_grade_level_count: 0,
        articles_at_grade_level_count: 0,
        articles_below_grade_level_count: 0,
        articles_weekly_trend_level: TrendLevel.None,
      },
    },
  };
